import styled from 'styled-components';

import { media } from 'DesignLibrary/global';

export const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 200px); // Account for header/footer
  ${media.TABLET`
    padding: 3rem 2rem;
    min-height: calc(100vh - 200px);
  `}
`;

export const FullScreenContainer = styled.div`
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #666;
  font-size: 1.2rem;
  font-weight: 500;
  padding: 2rem;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  padding: 2rem;
  max-width: 400px;
  width: 100%;
`;
